import { useHistory } from "react-router-dom";
import useNotification from "v4/hooks/useNotification";
import useAutoFetch from "v4/hooks/useAutoFetch";
import { generateUrl } from "v4/services/api.service";
import { CORE_SWITCH_USER } from "v4/data/apiRoutes";
import { useEffect } from "react";
import { useAuthContext } from "v4/contexts/AuthContext";
import { useTranslation } from "react-i18next";

export default function useSwitchUserPage() {
    const { t } = useTranslation();
    const { location, replace } = useHistory();
    const { switchUser } = useAuthContext();
    const { addErrorNotification } = useNotification();
    const query = new URLSearchParams(location.search);

    const request = query.get('request');
    const toUser = query.get('toUser');

    const { data, isLoading, isError, isFinished } = useAutoFetch(
        generateUrl(CORE_SWITCH_USER, { request, toUser }),
        null,
        { method: 'POST', credentials: 'include'  }
    );

    useEffect(() => {
        if (!request) {
            addErrorNotification(t('erreur_chargement_donnees'));
            replace('/');
        }

        if (isError) {
            replace('/');
        }
    }, [request, isError, addErrorNotification, replace, t]);

    useEffect(() => {
        if (!isFinished || isError || !data?.data?.auth_token) return;


        switchUser(data.data.auth_token);
        replace('/');
        window.location.reload();
    }, [data, isFinished, isError, switchUser, replace]);

    return {
        isLoading,
    }
}
